import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { AlertController, IonInfiniteScroll } from '@ionic/angular';
import { ToolsService } from 'src/app/services/tools.service';
import { ModalController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class PostCommentsPage {
    constructor(toolsService, authService, socialService, alertCtrl, modalController, analyticsService) {
        this.toolsService = toolsService;
        this.authService = authService;
        this.socialService = socialService;
        this.alertCtrl = alertCtrl;
        this.modalController = modalController;
        this.analyticsService = analyticsService;
        this.comments = [];
        this.offset = 0;
        this.limit = 20;
        this.loading = false;
        this.commentUpdated = false;
        this.formControl = new FormControl('', [Validators.required]);
        this.analyticsService.AnalyticsServiceModalView('post-comments');
    }
    ngOnInit() {
        this.getComments();
    }
    getComments() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            if (this.offset == 0)
                yield this.toolsService.showLoader();
            try {
                const response = yield this.socialService.getComments(this.post_id, this.limit, this.offset);
                console.log("response.results", response);
                let aux_comments = response;
                for (let post of aux_comments) {
                    post.created = this.toolsService.formatDate(post.created);
                }
                this.comments = this.comments.concat(aux_comments);
                if (response.length < 20)
                    this.infiniteScroll.disabled = true;
            }
            catch (error) {
                console.error('[MISSIONS PAGE](LoadMissions) Error comments', error);
            }
            this.offset += this.limit;
            this.infiniteScroll.complete();
            if (this.offset == this.limit)
                yield this.toolsService.dismissLoader();
            this.loading = false;
        });
    }
    createComment() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.formControl.valid) {
                yield this.toolsService.showLoader();
                try {
                    let result = yield this.socialService.createComment(this.formControl.value, this.authService.player_initial_data.id, this.post_id);
                    console.log("result", result);
                    this.socialService.notifyCommentCreated();
                    this.formControl.setValue("");
                    this.comments.push(result);
                }
                catch (error) {
                    console.error(error);
                }
                this.toolsService.dismissLoader();
            }
        });
    }
    closeModal(data = null) {
        this.modalController.dismiss(data);
    }
    doRefresh(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.offset = 0;
            this.comments = [];
            yield this.getComments();
            event.target.complete();
        });
    }
    removeComment(comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                header: "Eliminar publicación",
                message: "¿Estas seguro de que quieres eliminar el comentario?",
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel',
                    },
                    {
                        text: 'Eliminar',
                        handler: () => {
                            this.deleteComment(comment);
                        },
                    },
                ]
            });
            alert.present();
        });
    }
    deleteComment(comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                yield this.socialService.deleteComment(comment.id);
                this.comments.splice(this.comments.indexOf(comment), 1);
                this.toolsService.showSuccessToast("Comentario eliminado satisfactoriamente");
            }
            catch (error) {
                this.toolsService.showErrorToast("No se pudó eliminar la publicación, intenta de nuevo más tarde");
            }
            if (this.onDeleteCallback) {
                this.onDeleteCallback(comment.id, this.comments.length);
            }
            ;
            yield this.toolsService.dismissLoader();
        });
    }
    editComment(comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertCtrl.create({
                header: "Editar comentario",
                inputs: [
                    {
                        name: 'comment',
                        type: 'text',
                        value: comment.text,
                    }
                ],
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel',
                    },
                    {
                        text: 'Actualizar',
                        handler: (data) => {
                            this.updateComment(comment.id, data.comment);
                        },
                    },
                ]
            });
            alert.present();
        });
    }
    updateComment(commentId, newComment) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (newComment == "") {
                this.toolsService.showErrorToast("El comentario no puede estar vacío");
                return;
            }
            yield this.toolsService.showLoader();
            try {
                let response = yield this.socialService.updateComment(this.authService.player_initial_data.id, commentId, newComment);
                yield this.toolsService.showSuccessToast("Comentario actualizado satisfactoriamente");
            }
            catch (error) {
                console.error("(EDIT POST-COMMENT PAGE) Error in editComment", error);
                this.toolsService.showErrorToast();
            }
            this.comments = this.comments.map((comment) => {
                if (comment.id == commentId) {
                    comment.text = newComment;
                }
                return comment;
            });
            if (this.onEditCallback) {
                this.onEditCallback(commentId, newComment);
            }
            ;
            yield this.toolsService.dismissLoader();
        });
    }
}
